module.exports = __webpack_public_path__ + "static/media/mask.5f8c12e4.svg";